import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function TrainerPasswordStep({
  prefill,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  loading,
  onSubmit,
  onUseDifferentCode
}) {
  return (
    <form onSubmit={onSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="First Name" value={prefill?.firstName || ""} disabled />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Last Name" value={prefill?.lastName || ""} disabled />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth label="Email" value={prefill?.email || ""} disabled />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            helperText="At least 6 characters"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword((s) => !s)}
                    onMouseDown={(e) => e.preventDefault()}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            autoComplete="new-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword((s) => !s)}
                    onMouseDown={(e) => e.preventDefault()}
                    aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Grid>
      </Grid>

      <Button type="submit" variant="contained" fullWidth size="large" disabled={loading} sx={{ mt: 3, mb: 2 }}>
        {loading ? "Signing in..." : "Set password & continue"}
      </Button>
      <Button fullWidth onClick={onUseDifferentCode} disabled={loading}>
        Use a different code
      </Button>
    </form>
  );
}

export default TrainerPasswordStep;
